export enum MediaFileType {
  Image = 'Image',
  Video = 'Video',
  Document = 'Document',
  Unspecified = 'Unspecified',
}

export const UPLOAD_FROM_MEDIALIBRARY = 'media-library';
export const UPLOAD_FROM_COMPOSE = 'compose-box';
export const UPLOAD_FROM_EDITOR = 'editor';
